import React from "react";
import { BookingAlertsFragment, CustomerRefFragment, BookingIntro } from "@graphql";
import { BookingAlerts } from "./BookingAlerts";
import moment from "moment";
import { ConsultantServicePreferencesAlert } from "./components/consultant-service-preferences-alert";

type Props = {
  data: BookingAlertsFragment;
};

export function BookingAlertsQuery(props: Props) {
  if (!props.data) {
    return null;
  }

  const {
    _id,
    customersWithNoApproval: customers,
    bookingIntro,
    isFirstWeek,
    duplicateIds,
    BookingGroup: { nationalProcurementTravelRequired, travelTemplateLevel }
  } = props.data;

  return (
    <BookingAlerts
      needSignatureCustomers={joinCustomerRefs(customers.needSignature)}
      needSignatureTROkInAppCustomers={joinCustomerRefs(customers.needSignatureTROkInApp)}
      noApprovalCustomers={joinCustomerRefs(customers.noApproval)}
      noApprovalMonthlyCustomers={joinCustomerRefs(customers.noApprovalMonthly)}
      noApprovalShortCustomers={joinCustomerRefs(customers.noApprovalShortening)}
      noApprovalSpecialCustomers={joinCustomerRefs(customers.noApprovalSpecial)}
      consultantServicePref={<ConsultantServicePreferencesAlert bookingId={_id} />}
      consultantCare={props.data.Consultant.care}
      bookingIntro={getIntroText(bookingIntro, isFirstWeek)}
      nationalProcurementTravelRequired={getNationalProcurementTravelText(
        nationalProcurementTravelRequired,
        travelTemplateLevel
      )}
      duplicateIds={duplicateIds}
    />
  );
}

function joinCustomerRefs(refs: CustomerRefFragment[]) {
  return refs.map((x) => x.Name).join(", ");
}

function getIntroText(bookingIntro: BookingIntro, isFirstWeek: boolean): string {
  if (!isFirstWeek || !bookingIntro) {
    return null;
  }
  const { required, startDate, endDate, description } = bookingIntro;
  const from = startDate ? moment(startDate).format("L") : "";
  const to = endDate ? ` - ${moment(endDate).format("L")},` : "";
  return required && `${from}${to} ${description ? description : ""}`;
}

function getNationalProcurementTravelText(
  nationalProcurementTravelRequired: boolean,
  travelTemplateLevel: string,
  travelTemplateDescription?: string,
  travelTemplateValue?: number
): string {
  if (!nationalProcurementTravelRequired || !travelTemplateLevel) {
    return null;
  }

  // TODO Fix it
  // return `${travelTemplateLevel}, ${travelTemplateDescription}, ${travelTemplateValue}kr`;
  return `${travelTemplateLevel}`;
}
